import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import moment from 'moment';

export default class News extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get codename() {
    return this.system.codename;
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get publicationDate() {
    return get(this, '_data_publikacji.rawData.value', '');
  }

  get canonicalArticleUrl() {
    return get(this, '_kanoniczny_artykul.value', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0].url', '');
  }

  get photoMiniature() {
    return get(this, '_zdjecie_miniaturka.value[0].url', '');
  }

  get intro() {
    return get(this, '_wstep.value', '');
  }

  get text() {
    return get(this, '_tresc.value', '');
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get textHTML() {
    const html = get(this, '_tresc');
    return html ? html.value : '';
  }

  get tags() {
    return get(this, '_tag_w_artykule.value', []);
  }

  get comments() {
    return get(this, '_komentarz.value', []);
  }

  get companies() {
    return get(this, '_spolka.value', []);
  }

  get seo() {
    const seoModel = get(this, '_seo.value[0].model', {});

    if (!seoModel.title) {
      seoModel.title = this.title;
    }

    return seoModel;
  }

  get category() {
    return moment(this.publicationDate).format('YYYY');
  }
}



// WEBPACK FOOTER //
// ./src/models/News.model.js